import React from 'react';
import { motion } from 'framer-motion';
import phoneScreen from '@/assets/faqs/phone-screen.jpg';

interface FAQsHeroSectionProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
}

const FAQsHeroSection: React.FC<FAQsHeroSectionProps> = ({ searchQuery, onSearchChange }) => {
  return (
    <section className="relative bg-white py-16 lg:py-20 overflow-hidden">
      <div className="max-w-container-lg mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Side - Heading and Search */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="font-open-sans font-bold text-4xl lg:text-[48px] leading-[68px] text-[#323743] mb-6">
              How can we help?
            </h1>
            
            {/* Search Bar */}
            <div className="relative">
              <div className="absolute left-4 top-1/2 transform -translate-y-1/2">
                <svg
                  className="w-6 h-6 text-[#bdc1ca]"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
              <input
                type="text"
                placeholder="Type your keyword"
                value={searchQuery}
                onChange={(e) => onSearchChange(e.target.value)}
                className="w-full pl-12 pr-4 py-3.5 border border-[#bdc1ca] rounded-lg text-lg font-manrope text-[#323743] placeholder:text-[#bdc1ca] focus:outline-none focus:ring-2 focus:ring-brand-yellow focus:border-brand-yellow"
              />
            </div>
          </motion.div>

          {/* Right Side - Phone Illustration */}
          <div className="relative hidden lg:block">
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="relative w-full"
            >
              <img
                src={phoneScreen}
                alt="FAQ chat illustration showing phone with Ask us anything button and chat interface"
                className="w-full h-auto object-contain"
              />
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQsHeroSection;
